import Card from "@material-tailwind/react/Card";
import CardBody from "@material-tailwind/react/CardBody";
import React, { useEffect, useRef, useState } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { BsFileEarmarkPdfFill } from "react-icons/bs";

import { Colors } from "../../assets/Colors";
import Spinner from "../spinner/Spinner";

import Skeltons from "../loading/Skeltons";

export default function TableKaryawanPayrollDetail(props) {
  const [isSuccess, setisSuccess] = React.useState(false);
  const [totalJamLembur, settotalJamLembur] = useState(0);
  const [totLembursatu, settotLembursatu] = useState(0);
  const [totLemburdua, settotLemburdua] = useState(0);
  const [totLemburtiga, settotLemburtiga] = useState(0);
  const [totLemburempat, settotLemburempat] = useState(0);
  const [jamAct, setjamAct] = useState(0);
  const [jamKerja, setjamKerja] = useState(0);
  const [extraMakan, setextraMakan] = useState(0);
  const [totalMangkir, settotalMangkir] = useState(0);
  const tableRef = useRef(null);

  useEffect(() => {
    if (isSuccess) {
      toast.success("Success!", {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        theme: "light",
      });
      setisSuccess(false);
    }
  });
  useEffect(() => {
    if (Array.isArray(data)) {
      let totalJamLemburtemp = 0;
      let totalLemburtempsatu = 0;
      let totalLemburtempdua = 0;
      let totalLemburtemptiga = 0;
      let totalLemburtempempat = 0;
      let jamActtemp = 0;
      let jamKerja = 0;
      let extraMakanVal = 0;
      let mangkirVal = 0;
      var intJamLembur;
      var intTotalJam;
      data.map((keyName, i) => {
        intJamLembur = parseInt(keyName["JamLembur"]);
        intTotalJam = parseInt(keyName["TotalJam"]);
        if (!isNaN(intJamLembur) && intJamLembur >= 0) {
          totalJamLemburtemp += intJamLembur;
        }
        totalLemburtempsatu += parseFloat(
          checkDataLembur(keyName["PerhitunganLembur"], 1)
        );
        totalLemburtempdua += parseFloat(
          checkDataLembur(keyName["PerhitunganLembur"], 2)
        );
        totalLemburtemptiga += parseFloat(
          checkDataLembur(keyName["PerhitunganLembur"], 3)
        );
        totalLemburtempempat += parseFloat(
          checkDataLembur(keyName["PerhitunganLembur"], 4)
        );
        const jamActVal = parseInt(keyName["JamAct"]);
        if (!isNaN(jamActVal)) {
          jamActtemp += jamActVal;
        }

        if (intTotalJam > 0 && !keyName["IsOff"]) {
          jamKerja += intTotalJam;
        }

        if (keyName["ExtraMakan"] == "1") {
          extraMakanVal += 1;
        }

        if (keyName["Mangkir"] === "1") {
          mangkirVal += 1;
        }
      });
      settotLembursatu(totalLemburtempsatu * 1.5);
      settotLemburdua(totalLemburtempdua * 2);
      settotLemburtiga(totalLemburtemptiga * 3);
      settotLemburempat(totalLemburtempempat * 4);

      settotalJamLembur(totalJamLemburtemp);
      setjamAct(jamActtemp);

      setjamKerja(jamKerja);
      setextraMakan(extraMakanVal);
      settotalMangkir(mangkirVal);
    }
  }, [props.tableData]);

  const checkDataLembur = (array, cond) => {
    if (Array.isArray(array)) {
      let filtereddata = array.filter((data) => data.Perkalian === cond);

      return filtereddata.length > 0 ? filtereddata[0].JamLembur : 0;
    }
    return 0;
  };
  const NamaKaryawan = (array) => {
    if (Array.isArray(array)) {
      let filtereddata = array.filter((data) => data.NamaKaryawan != "");
      return filtereddata.length > 0
        ? `${filtereddata[0].NamaKaryawan} | ${filtereddata[0].Nik}`
        : "";
    }
    return false;
  };

  const checkedDetail = (array, cond) => {
    if (cond == false) {
      return false;
    }
    return array;
  };

  let data = props.tableData;
  if (props.usingMutation && !props.mutation.isLoading && data) {
    data = data.data;
  }

  const pdfColumns = [
    "Date",
    "In Act",
    "Out Act",
    "Jam Act",
    "In",
    "Out",
    "Jam Lembur",
    "1,5",
    "2",
    "3",
    "4",
    "Hari Kerja",
    "Extra Makan",
    "Mangkir",
    "Keterangan",
  ];

  const buildPdfRows = () =>
    (Array.isArray(data) ? data : []).map((k) => [
      k["Date"] || "",
      k["JamInAct"] || "",
      k["JamOutAct"] || "",
      (k["JamAct"] ?? "").toString(),
      k["JamIn"] || "",
      k["JamOut"] || "",
      `${k["JamLembur"] || 0} Jam ${k["MenitLembur"] || 0} Menit`,
      String(checkDataLembur(k["PerhitunganLembur"], 1)),
      String(checkDataLembur(k["PerhitunganLembur"], 2)),
      String(checkDataLembur(k["PerhitunganLembur"], 3)),
      String(checkDataLembur(k["PerhitunganLembur"], 4)),
      k["TotalJam"] > 0 && !k["IsOff"] ? String(k["TotalJam"]) : "0",
      k["ExtraMakan"] == "1" ? "1" : "0",
      k["Mangkir"] === "1" ? "1" : "0",
      k["Keterangan"] || "",
    ]);

  const handleExportPDF = () => {
    const rows = buildPdfRows();
    if (!rows.length) {
      toast.warn("Tidak ada data untuk di-export", { position: "top-center" });
      return;
    }
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(13);
    doc.text("Report Absensi Payroll " + (props.title || ""), 14, 14);
    autoTable(doc, {
      startY: 20,
      head: [pdfColumns],
      body: rows,
      styles: { fontSize: 7 },
      headStyles: { fillColor: [41, 128, 185] },
    });
    doc.save("Report_Payroll_" + (props.pin || "") + ".pdf");
  };

  return (
    <Card className="flex flex-col items-center content-center">
      <>
        {props.fetching ? (
          <div className="flex items-center">
            <Spinner />
          </div>
        ) : (
          <CardBody className="w-full pt-0 ">
            <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2">
              <div className="flex flex-row gap-2">
                <DownloadTableExcel
                  filename={"Report_Payroll_" + (props.pin || "")}
                  sheet="Absensi"
                  currentTableRef={tableRef.current}
                >
                  <button className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white  text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow">
                    {" "}
                    Download Excel
                  </button>
                </DownloadTableExcel>
                <button
                  type="button"
                  onClick={handleExportPDF}
                  className="flex flex-row items-center gap-2 my-2 sm:my-0 bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded shadow"
                >
                  <BsFileEarmarkPdfFill /> Download PDF
                </button>
              </div>
              <h5 className="text-xl font-bold text-gray-900">
                {NamaKaryawan(data)}
              </h5>
            </div>
            <div className="overflow-x-auto relative ">
              <table
                className="table-auto w-full bg-transparent border-collapse text-sm"
                ref={tableRef}
              >
                <thead>
                  <tr>
                    <th
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    ></th>
                    <th
                      colSpan={"3"}
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Jam Masuk
                    </th>
                    <th
                      colSpan={"2"}
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Jam Lembur
                    </th>
                    <th
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Jam Lembur Total
                    </th>
                    <th
                      colSpan={"4"}
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Over Time
                    </th>
                    <th
                      colSpan={"5"}
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    ></th>
                  </tr>
                  <tr>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Date
                    </th>
                    {/* <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      In Std
                    </th> */}
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      In Act
                    </th>
                    {/* <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Out Std
                    </th> */}
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Out Act
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Jam Act
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      In
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Out
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Total
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      1,5
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      2
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      3
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      4
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Hari Kerja
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Extra Makan Lembur
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Mangkir
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      Keterangan
                    </th>
                    <th
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      ##
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {props.usingMutation && props.mutation.isLoading ? (
                    <Skeltons />
                  ) : (
                    <>
                      {Array.isArray(data) && data.length > 0 ? (
                        data.map((keyName, i) => (
                          <tr key={keyName + i}>
                            <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                              {keyName["Date"]}
                            </th>
                            <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                              {keyName["JamInAct"]}
                            </th>
                            <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                              {keyName["JamOutAct"]}
                            </th>
                            <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                              {keyName["JamAct"]}
                            </th>
                            <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                              {keyName["JamIn"]}
                            </th>
                            <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                              {keyName["JamOut"]}
                            </th>
                            <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                              {keyName["JamLembur"] +
                                " Jam " +
                                keyName["MenitLembur"] +
                                " Menit"}
                            </th>
                            <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                              {checkDataLembur(keyName["PerhitunganLembur"], 1)}
                            </th>
                            <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                              {checkDataLembur(keyName["PerhitunganLembur"], 2)}
                            </th>
                            <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                              {checkDataLembur(keyName["PerhitunganLembur"], 3)}
                            </th>
                            <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                              {checkDataLembur(keyName["PerhitunganLembur"], 4)}
                            </th>
                            <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                              {keyName["TotalJam"] > 0 && !keyName["IsOff"]
                                ? keyName["TotalJam"]
                                : 0}
                            </th>
                            <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                              {keyName["ExtraMakan"] == "1" ? "1" : "0"}
                            </th>
                            <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                              {keyName["Mangkir"] === "1" ? "1" : "0"}
                            </th>
                            <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                              {keyName["Keterangan"]}
                            </th>
                            <th className="border border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                              {keyName["IsOff"] ? (
                                <input
                                  type="checkbox"
                                  checked={keyName["IsOff"]}
                                  name={`${keyName["Date"]}/${props.pin}`}
                                  onChange={(e) => {
                                    props.onchangeCheck(e);
                                    checkedDetail("", false);
                                  }}
                                />
                              ) : (
                                <input
                                  type="checkbox"
                                  name={`${keyName["Date"]}/${props.pin}`}
                                  onChange={(e) => {
                                    props.onchangeCheck(e);
                                    checkedDetail("", e.target.checked);
                                  }}
                                />
                              )}
                            </th>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={16}
                            className="text-center text-gray-500 py-8 border border-gray-200"
                          >
                            Tidak ada data absensi untuk periode ini.
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
                <tfoot>
                  <tr>
                    <th
                      colSpan={"3"}
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    ></th>
                    <th
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      {jamAct}
                    </th>
                    <th
                      colSpan={"2"}
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    ></th>
                    <th
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      {totalJamLembur}
                    </th>
                    <th
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      {totLembursatu}
                    </th>
                    <th
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      {totLemburdua}
                    </th>
                    <th
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      {totLemburtiga}
                    </th>
                    <th
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      {totLemburempat}
                    </th>
                    <th
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      {jamKerja}
                    </th>
                    <th
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      {extraMakan}
                    </th>
                    <th
                      style={{ color: Colors.primary, textAlign: "center" }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    >
                      {totalMangkir}
                    </th>
                    <th
                      colSpan={"2"}
                      style={{ color: Colors.primary }}
                      className="w-1/12 font-bold px-4 align-middle border border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                    ></th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </CardBody>
        )}
      </>
    </Card>
  );
}
